(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/extends', 'react', './AuthContext'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/extends'), require('react'), require('./AuthContext'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global._extends, global.react, global.AuthContext);
    global.withAuthProvider = mod.exports;
  }
})(this, function (exports, _extends2, _react, _AuthContext) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends3 = _interopRequireDefault(_extends2);

  var _react2 = _interopRequireDefault(_react);

  var _AuthContext2 = _interopRequireDefault(_AuthContext);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var withAuthProvider = function withAuthProvider(Component) {
    var C = function C(props) {
      return _react2.default.createElement(
        _AuthContext2.default.Consumer,
        null,
        function (authState) {
          return _react2.default.createElement(Component, (0, _extends3.default)({}, authState, props));
        }
      );
    };

    C.displayName = 'withAuthProvider(' + (Component.displayName || Component.name) + ')';

    return C;
  };

  exports.default = withAuthProvider;
});